import React from 'react'

import clsx from 'clsx'

import Link from 'components/Link'
import Logo from 'components/Logo'
import { useEventContext } from 'context/EventContext'

import classes from './SimpleIntegration.module.scss'

const SimpleIntegration = ({ integration }) => {
  const { addEvent } = useEventContext({ engagementComponent: 'product_integrations' })

  return (
    <div className={clsx({ [classes.isHidden]: !integration.isVisible })}>
      <div className={classes.root}>
        <Link
          href={integration.cta_urls.detail}
          className={classes.logoContainer}
          {...addEvent({
            name: 'engagement_product_click',
            engagementDestination: 'go-to_product_details',
            engagementDetails: 'logo_integrations',
          })}
        >
          <Logo className={classes.logo} src={`${integration.logo_url}`} alt={`${integration.name} logo`} size={44} />
        </Link>

        <Link
          variant="heading-xs"
          className={classes.listingName}
          href={integration.cta_urls.detail}
          {...addEvent({
            name: 'engagement_product_click',
            engagementDestination: 'go-to_product_details',
            engagementDetails: 'text-link_product-name-integrations',
          })}
        >
          <span className={classes.productName}>{integration.name} </span>
        </Link>
      </div>
      <div className={classes.divider} />
    </div>
  )
}

export default SimpleIntegration
